import { Select, SelectProps } from "@cofano/cck";
import { Box, Typography } from "@mui/material";
import DirectionsBoatFilledIcon from "@mui/icons-material/DirectionsBoatFilled";
import { FormattedDateWindow } from "utils/DateUtils";
import { DataFormat } from "utils";
import { useStoreState } from "ezStore";

export type VoyageLocalSelectOption = {
	id: number;
	voyageNumber: string;
	start?: number | null;
	end?: number | null;
	lastStatusChange?: {
		status: {
			description: string;
		};
	} | null;
};

const VoyageLocalSelect = ({
	voyages,
	...rest
}: Omit<SelectProps<VoyageLocalSelectOption, false>, "fetchOptions" | "getOptionLabel" | "renderOption" | "paginated"> & {
	voyages: VoyageLocalSelectOption[];
}) => {
	const { locale } = useStoreState(store => store.session);

	return (
		<Select
			getOptionLabel={option => `${option.voyageNumber} - ${option.lastStatusChange?.status.description}`}
			clearable={false}
			fetchOptions={voyages}
			renderOption={(props, option) => (
				<Box component="li"
					{...props}
					sx={{
						display: "flex",
						flexDirection: "column",
						alignItems: "flex-start !important",
					}}
				>
					<Typography variant="body2" sx={{ fontWeight: 500, color: "text.primary" }}>
						{option.voyageNumber} - {DataFormat.status(option.lastStatusChange?.status, locale)}
					</Typography>

					<Typography variant="caption"
						sx={{
							mt: 0.5,
							display: "flex",
							gap: 0.5,
						}}
					>
						<DirectionsBoatFilledIcon sx={{ fontSize: "0.875rem", color: "text.secondary" }} />
						{<FormattedDateWindow from={option.start} to={option.end} withoutYear />}
					</Typography>
				</Box>
			)}
			{...rest} />
	);
};

export default VoyageLocalSelect;
